import { collection, addDoc } from 'firebase/firestore';
import { firestore } from './firebase';

export interface WaitlistEntry {
    email: string;
    userType: 'tutor' | 'client' | '';
    comments: string;
    timestamp: Date;
}

export class WaitlistService {
    async addToWaitlist(entry: WaitlistEntry): Promise<void> {
        try {
            await addDoc(collection(firestore, 'signups'), entry);
        } catch (error) {
            console.error('Error adding document: ', error);
            throw error;
        }
    }
}

export const waitlistService = new WaitlistService();
